// instrumentation-client.ts
//
// Next.js client instrumentation (Next 15.3+ native file, turbopack-safe).
// Browser-side Sentry: unhandled exceptions + unhandled rejections in the
// app UI. No DSN = disabled no-op. NEXT_PUBLIC_VERCEL_ENV requires
// "Automatically expose System Environment Variables" on the Vercel
// project (on by default); falls back to development.

import * as Sentry from "@sentry/nextjs"

const environment = process.env.NEXT_PUBLIC_VERCEL_ENV ?? "development"

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  // Local dev never reports — see sentry.server.config.ts for the incident
  // that prompted this. Vercel preview and production still do.
  enabled:
    Boolean(process.env.NEXT_PUBLIC_SENTRY_DSN) && environment !== "development",
  environment,
  // Errors only: no tracing, no session replay.
  tracesSampleRate: 0,
})

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
